const bannersMap = new Map();

export default bannersMap;
